import ShareButton from './share_button'
import { connect } from 'react-redux'
import { getShareProps } from 'lib/share'
import { hide } from 'redux/modules/toast_notification'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { TOAST_NOTIFICATIONS } from 'shared/shared_consts'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  const isCopySuccess =
    state.toast_notification[TOAST_NOTIFICATIONS.COPY_SUCCESS]
  const shareProps = getShareProps(state, ownProps)

  return {
    campaign,
    isCopySuccess,
    ...shareProps,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onHideToast() {
      dispatch(hide(TOAST_NOTIFICATIONS.COPY_SUCCESS))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareButton)
